<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailCommande.achatVenteInterne.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns level is-multiline">
        <div class="column is-6 level-left">
          <div class="columns">
            <selecteur-action
              class="column is-narrow"
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="commandesAchatSelect.length > 0
              && commande.etat === constantes.ETAT_ENREGISTRE">
            </selecteur-action>
          </div>
        </div>
        <div class="column is-6 level-right">
          <div class="columns justify-content-flex-end">
            <div class="column is-narrow">
              <button class="button is-addOrEdit"
                      v-if="commandesAchat.length > 0"
                      :class="[{ 'button-access-no-permission'
             : !checkPermissions(constantes.COMMANDES.maj)
             || commande.etat !== constantes.ETAT_ENREGISTRE },
             { 'pointer-events-none' :  commande.etat !== constantes.ETAT_ENREGISTRE }]"
                      @click="checkPermissions(constantes.COMMANDES.maj)
                      ? openPopUpPrevention(commandesAchat.map(c => c.id)) : showPopUp()">
                {{ $t('detailCommande.achatVenteInterne.action.allGeneration') }}
              </button>
              <button class="button is-addOrEdit" v-else
                      :class="[{ 'button-access-no-permission'
                : !checkPermissions(constantes.COMMANDES.maj)
                || commande.etat !== constantes.ETAT_ENREGISTRE },
                { 'pointer-events-none' :  commande.etat !== constantes.ETAT_ENREGISTRE }]"
                          @click="checkPermissions(constantes.COMMANDES.maj)
                          ? openPopUpPrevention() : showPopUp()">
                    {{ $t('detailCommande.achatVenteInterne.action.allCreation') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <v-client-table :data="commandesAchat"
                          class='mgt-10px column is-12 is-paddingless'
                          :columns="columns"
                          :options="options">
            <div slot="selected" slot-scope="props" class="has-text-centered">
              <b-checkbox :value="props.row.selected" @input="updateSelected(props.row)">
              </b-checkbox>
            </div>
            <div  slot="code" slot-scope="props">
              <router-link-blank :message="props.row.code"
                                 :to="{ name: 'c.bodac.commandes-achatVenteInterne',
                                      params: { id: props.row.id } }"
                                 class-message="lien">
              </router-link-blank>
            </div>
            <div slot="fournisseur" slot-scope="props">
              <div v-if="props.row.intervenants && props.row.intervenants.length > 0">
                {{ props.row.intervenants.find(p => p.payeur).nomCommercial }}
              </div>
            </div>
            <div slot="etat" slot-scope="props">
              {{ $t(getEtatCommande(props.row.etat))}}
            </div>
            <div slot="etatInfo" slot-scope="props">
              <b-tooltip v-if="props.row.commentaireInterne
              && props.row.etat === constantes.ETAT_BROUILLON">
                <template v-slot:content>
                  <div v-for="(error, index) in
                  getTraductionCommentaireInterne(props.row.commentaireInterne)"
                  :key="index">
                    {{ $t(error.message, error.params) }}
                  </div>
                </template>
                <div class="mgv-auto mgr-5px"
                     :class="getColorStatuCommandeAchat(props.row.etat)">
                </div>
              </b-tooltip>
              <div class="mgv-auto mgr-5px" v-else
                   :class="getColorStatuCommandeAchat(props.row.etat)">
              </div>
            </div>
            <div slot="montantHt" slot-scope="props" class="has-text-right">
              {{ props.row.montantHt | formatDevise }}
            </div>
            <div  slot="referenceFournisseur"
                  v-if="props.row.commandeVenteInterne"
                  slot-scope="props">
              <router-link-blank :message="props.row.commandeVenteInterne.code"
                                 :to="{ name: 'c.bodac.commandes-venteInterne',
                                      params: { id: props.row.commandeVenteInterne.id } }"
                                 class-message="lien">
              </router-link-blank>
            </div>
            <div slot="status" slot-scope="props" v-if="props.row.commandeVenteInterne">
              {{ $t(getEtatCommande(props.row.commandeVenteInterne.etat))}}
            </div>
            <div slot="etatInfoCommandeVente" slot-scope="props"
                 v-if="props.row.commandeVenteInterne">
              <b-tooltip v-if=" props.row.commandeVenteInterne.commentaireInterne
              && props.row.commandeVenteInterne.etat === constantes.ETAT_BROUILLON"
                         position="is-left"
              >
                <template v-slot:content>
                  <div v-for="(error, index) in getTraductionCommentaireInterne(
                    props.row.commandeVenteInterne.commentaireInterne,
                    )"
                       :key="index">
                    {{ $t(error.message, error.params) }}
                  </div>
                </template>
                <div class="mgv-auto mgr-5px"
                     :class="getColorStatuCommandeAchat(props.row.commandeVenteInterne.etat)">
                </div>
              </b-tooltip>
              <div class="mgv-auto mgr-5px" v-else
                   :class="getColorStatuCommandeAchat(props.row.commandeVenteInterne.etat)">
              </div>
            </div>
          </v-client-table>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal"
             @close="popUpPrevention = false">
      <pop-up-prevention  :messHeader="$t('detailCommande.achatVenteInterne.warning.generation')"
                          v-if="commandesAchat.length > 0"
                          :cancel="$t('general.button.cancel')"
                          :validate="$t('general.button.next')"
                          @no="popUpPrevention = false"
                          @yes="regenererCommandeAchat">
      </pop-up-prevention>
      <pop-up-prevention  :messHeader="$t('detailCommande.achatVenteInterne.warning.creation')"
                          v-else
                          :cancel="$t('general.button.cancel')"
                          :validate="$t('general.button.next')"
                          @no="popUpPrevention = false"
                          @yes="creationCommandeAchat">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import selecteurAction from '@/components/general/selecteurAction';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { ACTION_REGENERATION_COMMANDE_ACHAT } from '@/configuration/commande/commandeConf';
import { DEVIS_COMMANDE_ETAT, ETAT_BROUILLON, ETAT_ENREGISTRE } from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { regenererCommandeAchat } from '@/api/commandeAchat';
import { regenerationCommandeAchatVenteInterne } from '@/api/commande';
import messageErreur from '@/services/general/messageErreur';
import traductionMessageCommentaireInterne
  from '@/services/bodac/commande/commandeAchat/traductionMessageCommentaireInterne';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    commandesAchat: {
      required: true,
      type: Array,
    },
    commande: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      popUpPrevention: false,
      idsCommandeAchat: [],
      constantes: {
        ETAT_BROUILLON,
        ETAT_ENREGISTRE,
        COMMANDES,
      },
      actions: [
        { action: ACTION_REGENERATION_COMMANDE_ACHAT, translation: 'detailCommande.achatVenteInterne.action.generation' },
      ],
    };
  },
  components: {
    selecteurAction,
    popUpPrevention,
    routerLinkBlank,
  },
  computed: {
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    columns() {
      return ['selected', 'fournisseur', 'code', 'etat', 'etatInfo', 'montantHt', 'referenceFournisseur', 'status', 'etatInfoCommandeVente'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('detailCommande.achatVenteInterne.tab.code'),
          fournisseur: this.$t('detailCommande.achatVenteInterne.tab.fournisseur'),
          etat: this.$t('detailCommande.achatVenteInterne.tab.etat'),
          montantHt: this.$t('detailCommande.achatVenteInterne.tab.montantHt'),
          referenceFournisseur: this.$t('detailCommande.achatVenteInterne.tab.referenceFournisseur'),
          status: this.$t('detailCommande.achatVenteInterne.tab.status'),
          etatInfoCommandeVente: '',
          etatInfo: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allCommandesAchatSelect;
                    this.commandesAchat.forEach(item => {
                      item.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        columnsClasses: {
          selected: 'colonneSelected',
          etatInfo: 'colonneSelected',
          etatInfoCommandeVente: 'colonneSelected',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        sortable: ['code', 'fournisseur', 'etat', 'montantHt', 'referenceFournisseur', 'status'],
      };
    },
    commandesAchatSelect() {
      return this.commandesAchat.filter((c) => c.selected);
    },
    allCommandesAchatSelect() {
      return this.commandesAchat.length > 0 && !this.commandesAchat.some(c => !c.selected);
    },
    iconSelectTotal() {
      if (this.allCommandesAchatSelect) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async regenererCommandeAchat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpPrevention = false;
        await regenererCommandeAchat(this.idsCommandeAchat);
        this.$emit('reloadCommandeAchat');
        this.idsCommandeAchat = [];
        messageSucces(this.$i18n.t('detailCommande.achatVenteInterne.success.generation'));
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async creationCommandeAchat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.popUpPrevention = false;
        await regenerationCommandeAchatVenteInterne(this.commande.id);
        this.idsCommandeAchat = [];
        messageSucces(this.$i18n.t('detailCommande.achatVenteInterne.success.creation'));
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    openPopUpPrevention(ids) {
      this.idsCommandeAchat = ids;
      this.popUpPrevention = true;
    },
    getTraductionCommentaireInterne(commentaire) {
      return traductionMessageCommentaireInterne(commentaire, this.societesInformations);
    },
    getColorStatuCommandeAchat(etat) {
      return etat === ETAT_BROUILLON ? 'round-circle-danger' : 'round-circle-success';
    },
    getEtatCommande(etat) {
      return DEVIS_COMMANDE_ETAT.find((etatInList) => {
        return etatInList.code === etat;
      }).libelle;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_REGENERATION_COMMANDE_ACHAT:
          this.openPopUpPrevention(this.commandesAchatSelect.map(c => c.id));
          break;
        default:
      }
    },
    updateSelected(commande) {
      const commandeAchat = this.commandesAchat.find((c) => c.id === commande.id);
      commandeAchat.selected = !commande.selected;
    },
  },
};

</script>
